import { observable, action } from 'mobx'
import Api from '@api/yun_xuan/liteAppApi'
import { message } from 'hljd'
import { hashHistory } from 'react-router'

class Store {
  @observable audit_status = 0
  @observable visible = false
  @observable modal_type = null
  @observable official_version = ''
  @observable audit_version = ''
  @observable test_version = ''
  @observable category = []
  @observable user_info = {}
  @observable loading = false

  @action
  showModal = type => () => {
    this.visible = true
    this.modal_type = type === 'remove' ? 1 : this.category.length > 0 ? 3 : 2
  }

  @action
  cancel = () => {
    this.visible = false
    this.modal_type = null
  }

  @action
  submit = type => () => {
    switch (+type) {
      case 1:
        this.cancelAuth()
        this.visible = false
        this.modal_type = null
        break
      case 2:
        window.open(
          'https://mp.weixin.qq.com/debug/wxadoc/introduction/#面向个人开发者开放的服务类目'
        )
        this.visible = false
        this.modal_type = null
        break
      case 3:
        this.submitAudit()
        this.visible = false
        this.modal_type = null
        break
    }
  }
  @action
  cancelAuth = async () => {
    const { success } = await Api.cancelAuthApi()
    if (success) {
      hashHistory.push('/localMerchant/liteApp/authorize')
      message.success('取消授权成功')
    }
  }
  @action
  getVerList = async () => {
    this.loading = true
    const { data, success, msg } = await Api.getVersionListApi()
    const { categorys, user_info, versions } = data || {}
    if (!success) {
      this.loading = false
      if (msg.indexOf('重新授权') > -1) {
        hashHistory.push('/localMerchant/liteApp/authorize')
      }
      return
    }
    this.user_info = user_info
    this.official_version = versions.filter(item => +item.status === 2)[0]
    this.audit_version = versions.filter(item => +item.status === 1)[0]
    this.test_version = versions.filter(item => +item.status === 0)[0]
    this.category = categorys
    this.loading = false
  }

  @action
  submitAudit = async () => {
    const { category, test_version } = this
    const { success } = await Api.submitAuditApi({
      category: category[test_version.category_id],
      id: test_version.id,
      category_id: test_version.category_id
    })
    if (success) {
      this.getVerList()
      message.success('提交审核成功')
    }
  }

  @action
  toModify = () => {
    hashHistory.push('/localMerchant/liteApp/setLayout')
  }
  @observable QRCodeVisible = false
  @observable QRCodePath = ''
  @action
  showQrCode = path => () => {
    this.QRCodeVisible = true
    this.QRCodePath = path
  }
  @action
  cancelQrCode = () => {
    this.QRCodeVisible = false
  }
}

export default new Store()
